import type { ReactNode } from "react";
import { Link } from "react-router";
import { ArrowLeft } from "lucide-react";

export function AuthLayout({ title, subtitle, children, back = "/" }: { title: ReactNode; subtitle?: ReactNode; children: ReactNode; back?: string }) {
  return (
    <div className="min-h-dvh bg-canvas">
      <div className="mx-auto max-w-md px-5 pb-[calc(env(safe-area-inset-bottom)+24px)] pt-[calc(env(safe-area-inset-top)+16px)]">
        <Link to={back} className="-ml-2 inline-flex size-10 items-center justify-center rounded-full hover:bg-sunken" aria-label="Back">
          <ArrowLeft className="size-6" />
        </Link>
        <div className="mt-4 flex items-center gap-2">
          <img src="/favicon.svg" alt="" className="size-9" />
          <span className="font-black tracking-tight">Meaningful Rewards</span>
        </div>
        <h1 className="mt-6 text-3xl font-black tracking-tight">{title}</h1>
        {subtitle && <p className="mt-2 text-muted">{subtitle}</p>}
        <div className="mt-6">{children}</div>
      </div>
    </div>
  );
}
